/**
 * Define the possible data that a Dialog component can expose
 */
import { EventEmitter } from '@angular/core';
import { ModalExit } from './modal.model';
import { ModalButtonModel } from './modal-button.model';

export abstract class AbstractModal {
	data: any;
	content: any;
	successEvent = new EventEmitter<any>();
	buttons: Array<ModalButtonModel> = new Array<any>();
	private title = '';

	/**
	 * Change
	 * @param title
	 */
	setTitle(title: string): void {
		this.title = title;
	}

	/**
	 * Get Current title
	 * @param title
	 */
	getTitle(): string {
		return this.title;
	}

	/**
	 * Dismiss the Dialog
	 */
	public onCancelClose(result: any = {}): void {
		result.status = ModalExit.CLOSE;
		this.successEvent.emit(result);
	}

	/**
	 * Generic dismiss method
	 */
	public abstract onDismiss(): void;

	/**
	 * Close the Dialog successfully
	 */
	public onAcceptSuccess(result: any = {}): void {
		result.status = ModalExit.ACCEPT;
		this.successEvent.emit(result);
	}

	/**
	 * emit the result
	 */
	public onSaveSuccess(result: any = {}): void {
		this.successEvent.emit(result);
	}

	/**
	 * Close the Dialog by Cancel/Close/Dismiss
	 * @param result
	 */
	onCancel(): void {
		const data = { cancel: true };
		this.onCancelClose(data);
	}
}
